import React from 'react';
import { Camera, Layers, MapPin } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <Camera className="w-8 h-8 text-[#3A3A3A]" strokeWidth={1.5} data-id="element-97" />,
    title: 'Take a photo',
    description: "Snap a picture of the card—front and back if you'd like."
  }, {
    icon: <Layers className="w-8 h-8 text-[#3A3A3A]" strokeWidth={1.5} data-id="element-98" />,
    title: 'Organized by family',
    description: 'Cards are automatically grouped by sender and sorted by year.'
  }, {
    icon: <MapPin className="w-8 h-8 text-[#3A3A3A]" strokeWidth={1.5} data-id="element-99" />,
    title: 'Track address changes',
    description: 'See when families move, so you always have their latest address.'
  }];
  return <section className="w-full bg-[#FAF8F5] px-6 py-16 md:py-24" data-id="element-100">
      <div className="max-w-5xl mx-auto" data-id="element-101">
        <h2 className="font-['DM_Sans'] text-3xl md:text-4xl font-medium text-[#3A3A3A] mb-12 md:mb-16 text-center" data-id="element-102">
          Three simple steps
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-103">
          {steps.map((step, index) => <div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-[#B8A99A]/10 flex flex-col items-center text-center h-full" data-id="element-104">
              <div className="mb-6 p-4 bg-[#F0EBE3] rounded-full" data-id="element-105">
                {step.icon}
              </div>
              <h3 className="font-['DM_Sans'] text-xl font-medium text-[#3A3A3A] mb-3" data-id="element-106">
                {step.title}
              </h3>
              <p className="text-[#3A3A3A]/70 leading-relaxed" data-id="element-107">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}